import { useState } from 'react';

const ICON_SVG_SRC= "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAuNSIgY3k9IjEwLjUiIHI9IjEwIiBzdHJva2U9IiMwMDU1ODEiLz4KPHBhdGggZD0iTTEwLjQ4NjUgNS40NkMxMC4yNzMyIDUuNDYgMTAuMDg2NSA1LjM4IDkuOTI2NDggNS4yMkM5Ljc3OTgyIDUuMDYgOS43MDY0OCA0Ljg2NjY3IDkuNzA2NDggNC42NEM5LjcwNjQ4IDQuNDEzMzMgOS43Nzk4MiA0LjIyNjY3IDkuOTI2NDggNC4wOEMxMC4wODY1IDMuOTIgMTAuMjczMiAzLjg0IDEwLjQ4NjUgMy44NEMxMC43MTMyIDMuODQgMTAuODk5OCAzLjkyIDExLjA0NjUgNC4wOEMxMS4yMDY1IDQuMjI2NjcgMTEuMjg2NSA0LjQxMzMzIDExLjI4NjUgNC42NEMxMS4yODY1IDQuODY2NjcgMTEuMjA2NSA1LjA2IDExLjA0NjUgNS4yMkMxMC44OTk4IDUuMzggMTAuNzEzMiA1LjQ2IDEwLjQ4NjUgNS40NlpNOS45NjY0OCA3LjQ2SDExLjAyNjVWMTdIOS45NjY0OFY3LjQ2WiIgZmlsbD0iIzAwNTU4MSIvPgo8L3N2Zz4K";

const HelpText = (props) => {
  const {
    text,
    srText,
    preventMobileAdjustment,
    name
  } = props;

  const [ visible, setVisible ] = useState(false);
  const [ hover, setHover ] = useState(false);
  const showPopup = hover || visible;
  const popupClass = `help-text ${preventMobileAdjustment ? '' : 'right-align'}`;

  return (
    <div className="help-text-container">
      <button
        data-name={name}
        className="help-text-button"
        onBlur={ () => setVisible(false) }
        onMouseOver={ () => setHover(true) }
        onMouseOut={ () => setHover(false) }
        onClick={ (e) => {
          e.preventDefault();
          setVisible(!visible);
          setHover(false);
        }}
      >
        <span aria-hidden className="help-icon"><img src={ICON_SVG_SRC} alt="a button with an i symbol"/></span>
        <span className="sr-hide">{srText}</span>
      </button>
      { showPopup ? <span className={popupClass}>{text}</span> : null }
    </div>
  );
};

export default HelpText;
